import { Component, OnInit } from '@angular/core'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { CacheService } from '../cache.service'
import { FilterService } from '../filter.service'
// import { PhoneNumberValidator } from '../date-range.validator'
import moment from 'moment'

@Component({
    selector: 'app-filters',
    templateUrl: './filters.component.html',
    styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {
    form: FormGroup;

    filterDateOptions = {
        format: 'MM/DD/YYYY',
        showClear: true,
        showClose: true,
        showTodayButton: true,
        useCurrent: false,
        allowInputToggle: true,
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar',
            up: 'fa fa-chevron-up',
            down: 'fa fa-chevron-down',
            previous: 'fa fa-chevron-left',
            next: 'fa fa-chevron-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash',
            close: 'fa fa-times'
            },
        widgetPositioning: {
                horizontal: 'right',
                vertical: 'top'
            }
    };

    constructor(
        private fb: FormBuilder,
        // private calendar: NgbCalendar,
        private cacheService: CacheService,
        private filterService: FilterService
    ) {
        this.prepareForm()
    }

    ngOnInit() {}

    prepareForm(){
        this.form = this.fb.group({
            budgetDiscipline: [null],
            credit: [null],
            endDate: [null],
            evaluations: [this.filters.evaluations],
            image: [null],
            region: [null],
            tagStatewide: [null],
            search: [null],
            startDate: [null],
            status: [null],
            structure: [null],
        });

        this.form.get('budgetDiscipline').valueChanges.subscribe((value) => {
            this.filters.budgetDisciplines = value ? [value] : [];
            this.update();
        });

        this.form.get('credit').valueChanges.subscribe((value) => {
            this.filters.credits = value ? [value] : [];
            this.update();
        });

        this.form.get('endDate').valueChanges.subscribe((value) => {
            if (!moment(value).isValid()) return;
            this.filters.endDate = moment(value).format('YYYY-MM-DD');
            this.update();
        });

        this.form.get('evaluations').valueChanges.subscribe((value) => {
            this.filters.evaluations = value;
            this.update();
        });

        this.form.get('image').valueChanges.subscribe((value) => {
            this.filters.image = value;
            this.update();
        });

        this.form.get('region').valueChanges.subscribe((value) => {
            this.filters.regions = value ? [value] : [];
            this.update();
        });

        this.form.get('tagStatewide').valueChanges.subscribe((value) => {
            this.filters.tagsStatewide = value ? [value] : [];
            this.update();
        });

        this.form
            .get('search')
            .valueChanges.pipe(distinctUntilChanged(), debounceTime(500))
            .subscribe((value) => {
                this.filters.search = value;
                this.update();
            });

        this.form.get('startDate').valueChanges.subscribe((value) => {
            if (!moment(value).isValid()) return;
            this.filters.startDate = moment(value).format('YYYY-MM-DD');
            this.update();
        });

        this.form.get('status').valueChanges.subscribe((value) => {
            this.filters.statuses = value ? [value] : [];
            this.update();
        });

        this.form.get('structure').valueChanges.subscribe((value) => {
            this.filters.structures = value ? [value] : [];
            this.update();
        });
    }

    update() {
        // valueChanges fires before value update complete
        setTimeout(() => {
            this.filterService.update();
        });
    }

    get isLoading() {
        return this.cacheService.isLoading;
    }
    get filters() {
        return this.filterService.filters;
    }
    get budgetDiscipline() {
        return this.form.get('budgetDiscipline');
    }
    get credit() {
        return this.form.get('credit');
    }
    get endDate() {
        return this.form.get('endDate');
    }
    get evaluations() {
        return this.form.get('evaluations');
    }
    get image() {
        return this.form.get('image');
    }
    get region() {
        return this.form.get('region');
    }
    get tagStatewide() {
        return this.form.get('tagStatewide');
    }
    get search() {
        return this.form.get('search');
    }
    get startDate() {
        return this.form.get('startDate');
    }
    get status() {
        return this.form.get('status');
    }
    get structure() {
        return this.form.get('structure');
    }
    get regions() {
        return this.cacheService.regionsScoped;
    }
    get tagsStatewide() {
        return this.cacheService.tagsStatewide;
    }
    get budgetDisciplines() {
        return this.cacheService.budgetDisciplines;
    }
    get statuses() {
        return this.cacheService.statuses;
    }
    get structures() {
        return this.cacheService.structures;
    }
    get calendarScopes() {
        return this.cacheService.calendarScopes;
    }
    get yesNo() {
        return this.cacheService.yesNo;
    }
}